import type { DirectCoupangSearchExecution } from '../../../infrastructure/CpSearchClient';

export interface DirectSearchReference {
  productId: string;
  requestId: string;
  executionId?: string;
}

export const selectDirectSearchReference = (
  productId: string,
  storedReference: DirectSearchReference | undefined,
  pendingReference: DirectSearchReference | null,
  forceNewRequest: boolean,
  requestId: string,
): DirectSearchReference => {
  if (forceNewRequest) {
    return { productId, requestId };
  }
  return storedReference ?? (pendingReference?.productId === productId ? pendingReference : { productId, requestId });
};

export const directSearchFailureMessage = (execution: DirectCoupangSearchExecution): string => {
  if (execution.status === 'SUBMISSION_UNKNOWN' || execution.errorCategory === 'submission-unknown') {
    return 'Coupang search submission outcome is unknown. Refresh this product before trying again.';
  }

  switch (execution.errorCategory) {
    case 'provider-failure':
    case 'provider-payload-invalid':
    case 'provider-quota':
    case 'provider-timeout':
      return 'Coupang search provider did not complete the search.';
    case 'storage-failure':
    case 'storage-unknown':
      return 'Coupang search completed but results could not be saved.';
    case 'secret-unavailable':
    case 'control-plane-failure':
      return 'Coupang search could not be started by the service.';
    default:
      return 'Coupang search did not complete.';
  }
};
